import React from 'react';
import { ArrowRight } from 'lucide-react';
import { MaskedLines, Reveal } from './reveal';

export default function HammerAbout() {
  return (
    <section
      id="hammer-about"
      data-testid="hammer-about-section"
      className="relative bg-[#050608] border-t border-white/5 py-16 sm:py-20 lg:py-28 overflow-hidden"
    >
      <div className="absolute inset-0 grid-bg opacity-30 pointer-events-none" />

      <div className="relative max-w-4xl mx-auto px-5 sm:px-6 lg:px-10 text-center">
        <Reveal>
          <div className="flex items-center justify-center gap-3 mb-3 sm:mb-4">
            <span className="h-px w-8 sm:w-10 bg-cyan-400" />
            <span className="font-tech text-cyan-300 text-[10px] sm:text-[11px] uppercase tracking-[0.28em]">
              About Absolute
            </span>
            <span className="h-px w-8 sm:w-10 bg-cyan-400" />
          </div>
        </Reveal>
        <h2 className="font-display text-white text-3xl sm:text-4xl md:text-5xl font-bold uppercase leading-[1.05] tracking-tight">
          <MaskedLines
            delay={0.15}
            lines={[
              'Marine contractors',
              <span className="text-cyan-300">first.</span>,
            ]}
          />
        </h2>
        <Reveal delay={0.3}>
          <p className="mt-6 text-zinc-300 text-base sm:text-lg leading-relaxed">
            Absolute is a Southwest Florida marine construction outfit that got
            tired of buying broken equipment. We now design and build our own —
            HDPE work barges and pneumatic pile-driving hammers — so every
            piece of gear on our jobs is one we'd bet our own weekend on. If
            we don't trust it, we don't ship it.
          </p>
        </Reveal>

        <Reveal delay={0.45}>
          <div className="mt-8 flex flex-wrap items-center justify-center gap-3 sm:gap-4">
            <a
              href="https://absolutebarges.com"
              data-testid="hammer-about-visit-barges"
              className="btn-ghost px-5 sm:px-6 py-3 rounded-md text-xs sm:text-sm uppercase tracking-[0.16em] sm:tracking-[0.18em] whitespace-nowrap inline-flex items-center gap-2"
            >
              See Our HDPE Barges <ArrowRight className="w-4 h-4" />
            </a>
            <a
              href="https://absolutebarges.com/#why"
              data-testid="hammer-about-more-btn"
              className="btn-teal px-5 sm:px-6 py-3 rounded-md text-xs sm:text-sm uppercase tracking-[0.16em] sm:tracking-[0.18em] whitespace-nowrap inline-flex items-center gap-2"
            >
              More About Us <ArrowRight className="w-4 h-4" />
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
